import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  createFetchManyHandler,
  createSaveHandler,
  createUpdateHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  fetchInventoryTags,
  createInventoryTag,
  updateInventoryTag,
  deleteInventoryTag
} from '../../sagas/routines';
import {
  clearIventoryTags,
  inventoryTagsOnChangePage,
  inventoryTagsOnChangeOrder
} from '../../actions/tag';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:desc'
};

const clearTagsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    fetched: false,
    pagination: resetPaginationState(state.pagination)
  })
});

const updateInventoryTagCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: tag }) =>
    set('pagination.currentPage', tag, state)
});

const updateInventoryTagsOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchInventoryTags),
  ...createSaveHandler(createInventoryTag),
  ...createUpdateHandler(updateInventoryTag),
  ...createDeleteHandler(deleteInventoryTag),
  ...clearTagsHandler(clearIventoryTags),
  ...updateInventoryTagCurrentPageHandler(inventoryTagsOnChangePage),
  ...updateInventoryTagsOnChangeOrderHandler(inventoryTagsOnChangeOrder)
});
